import React from 'react';
import PropTypes from 'prop-types';
import { Link } from 'gatsby';
import { SocialLinks } from '../SocialLinks';
import styles from './footer.module.scss';
import { getEnv } from '../../utils/';
import monopolyLogo from './assets/monopoly-logo.png';

export const TestLogin = () => {
    if (typeof window === 'undefined') {
        return null;
    }
    return getEnv(window.location) === 'qa' ? (
        <div className={styles.testlogin}>
            <a href="/monopoly/enter/testlogin.php">test login</a>
        </div>
    ) : null;
};

export const Footer = ({ footerMenu = [], socialLinks = [] }) => {
    return (
        <footer className={styles.footer}>
            <div className={styles.footerTop}>
                <div className={styles.secondaryNav}>
                    <div className={styles.monopolyCopyright}>
                        <img src={monopolyLogo} alt="MONOPOLY" />
                        <p>
                            The MONOPOLY name and logos, the distinctive design
                            of the gameboard, the four corner squares, the MR.
                            MONOPOLY name and character, as well as each of the
                            distinctive elements of the board and playing pieces
                            are trademarks of Hasbro for its property trading
                            game &amp; equipment. ©1935, 2021 Hasbro. All Rights
                            Reserved. Licensed by Hasbro. Hasbro is not a
                            sponsor of this promotion.
                        </p>
                    </div>
                </div>
                <div className={styles.social}>
                    <div className={styles.gridContainer}>
                        {footerMenu.map((link, key) => (
                            <div
                                className={
                                    (styles.secondaryNavItem,
                                    styles.gridItemLink)
                                }
                                key={`secondary-nav--${key}`}
                            >
                                <Link
                                    to={link.uri}
                                    className={styles.secondaryNavLink}
                                    activeClassName={styles.active}
                                >
                                    {link.title}
                                </Link>
                            </div>
                        ))}
                        <div className={styles.gridItemSocial}>
                            <SocialLinks links={socialLinks} />
                        </div>
                    </div>
                </div>
            </div>
            <div className={styles.footerBottom}>
                <a
                    href="https://www.galottery.com/en-us/about-us/play-responsibly.html"
                    target="_blank"
                    rel="noopener noreferrer"
                >
                    PLEASE PLAY RESPONSIBLY
                </a>
                . It&apos;s all about fun. You must be 18 or older to play
                Lottery games.
            </div>
            <TestLogin />
        </footer>
    );
};

Footer.propTypes = {
    footerMenu: PropTypes.array.isRequired,
    socialLinks: PropTypes.array,
};

export default Footer;
